<div class="section-shell">
  <button
    type="button"
    class="section-add"
    [disabled]="!openedCredit"
    matTooltip="Добави напомняне"
    aria-label="Добави напомняне"
    (click)="sectionPanel.open(); openReminderDialog()"
  >
    <mat-icon>add</mat-icon>
  </button>

  <mat-expansion-panel #sectionPanel class="section-panel mat-elevation-z0">
    <mat-expansion-panel-header collapsedHeight="44px" expandedHeight="44px">
      <mat-panel-title>
        Напомняния
        <span class="section-count">{{ reminders.length }}</span>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="reminder-list">
      @for (reminder of reminders; track reminder.id) {
        <div
          class="reminder-tile"
          [class.expanded]="expandedReminderId === reminder.id"
        >
          <div class="reminder-row">
            <button
              type="button"
              class="reminder-toggle"
              [disabled]="!reminder.note"
              [attr.aria-expanded]="
                reminder.note ? expandedReminderId === reminder.id : null
              "
              [attr.aria-controls]="
                reminder.note ? 'reminder-note-' + reminder.id : null
              "
              (click)="
                expandedReminderId =
                  expandedReminderId === reminder.id ? null : reminder.id
              "
            >
              <mat-icon class="alarm">alarm_on</mat-icon>

              <span class="reminder-time">
                {{ reminder.time | date: 'dd.MM.yy HH:mm' }}
              </span>

              @if (reminder.note; as note) {
                <mat-icon class="note-icon">notes</mat-icon>

                <span class="note-preview">
                  {{ note.content || 'Бележка с теми' }}
                </span>

                <mat-icon class="chevron">
                  {{
                    expandedReminderId === reminder.id
                      ? 'expand_less'
                      : 'expand_more'
                  }}
                </mat-icon>
              }
            </button>

            <button
              type="button"
              class="remove-button"
              matTooltip="Деактивирай напомнянето"
              aria-label="Деактивирай напомнянето"
              (click)="deactivateReminder(reminder)"
            >
              <mat-icon>remove</mat-icon>
            </button>
          </div>

          @if (reminder.note; as note) {
            <div
              class="note-details"
              [id]="'reminder-note-' + reminder.id"
              [hidden]="expandedReminderId !== reminder.id"
            >
              @if (note.content) {
                <div class="note-content">{{ note.content }}</div>
              }

              @if (note.topics?.length) {
                <div class="note-topics">
                  @for (topic of note.topics; track topic.id) {
                    <div class="topic-row">
                      <span class="topic-code">{{ topic.code }}</span>
                      <span class="topic-label">{{ topic.path }}</span>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </mat-expansion-panel>
</div>
